function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import 'assets/styles/app.scss';
import 'foundation-sites';
import initDarkmode from './darkMode';
const loadedComponents = [];
document.addEventListener('DOMContentLoaded', /*#__PURE__*/_asyncToGenerator(function* () {
  /**
   * Globally call foundation
   */
  $(document).foundation();
  /**
   * Bootstrap the components
   */
  for (const dataComponent of document.querySelectorAll('[data-component]')) {
    let componentName = dataComponent.dataset.component;
    if (loadedComponents.indexOf(componentName) === -1) {
      loadedComponents.push(componentName);
      try {
        let component = yield import(/* WebpackMode: "lazy" */
        /* webpackPrefetch: true */
        /* webpackPreload: true */
        `components/${componentName}/${componentName}.js`);
        component.default();
      } catch (error) {
        console.error('Loading error: ', error);
      }
    }
  }
  initDarkmode();

  // // Horst, Netherlands coordinates
  // const latitude = 51.453667;
  // const longitude = 6.050344;
  // // Function to fetch sunrise and sunset times and convert them to GMT+2
  // async function fetchSunTimes(lat, lng) {
  // 	try {
  // 		const response = await fetch(`https://api.sunrise-sunset.org/json?lat=${lat}&lng=${lng}&formatted=0`);
  // 		const data = await response.json();
  // 		const sunriseUTC = new Date(data.results.sunrise);
  // 		const sunsetUTC = new Date(data.results.sunset);
  // 		const sunrise = new Date(sunriseUTC.setHours(sunriseUTC.getHours())); // Adjust for GMT+2
  // 		const sunset = new Date(sunsetUTC.setHours(sunsetUTC.getHours()));   // Adjust for GMT+2
  // 		return { sunrise, sunset };
  // 	} catch (error) {
  // 		console.error('Failed to fetch sun times:', error);
  // 		return null;
  // 	}
  // }
  // const { sunrise, sunset } = await fetchSunTimes(latitude, longitude);
  // let now = new Date();
  // console.log(now);
  // console.log(sunrise);
  // console.log(sunset);
  // // Set dark or light mode based on sunrise and sunset times
  // if (now > sunrise && now < sunset) {
  // 	document.querySelector('body').classList.remove('is-darkness');
  // } else {
  // 	document.querySelector('body').classList.add('is-darkness');
  // }
}));